import { render, staticRenderFns } from "./data-template.vue?vue&type=template&id=27553d9a&scoped=true&"
import script from "./data-template.vue?vue&type=script&lang=js&"
export * from "./data-template.vue?vue&type=script&lang=js&"
import style0 from "./data-template.scss?vue&type=style&index=0&id=27553d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27553d9a",
  null
  
)

export default component.exports